import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { ScheduleQueueSearchModel } from "src/app/core/models/schedule-queue-model";
import { ScheduleQueueService } from "src/app/core/services/schedule-services";
import { ScheduleQueueGridService } from "../shared/schedule-queue-grid-service";
import { ScheduleQueueMapperService } from "../shared/schedule-queue-mapper.service";
import { DateConverterService } from "src/app/core/utils/date-converter.service";

@Component({
    selector: 'op-schedule-queue-reaccom-order-table',
    templateUrl: './schedule-queue-reaccom-order-table.component.html'
})
export class ScheduleQueueReaccomOrderTableComponent implements OnInit {

    @Input() parentScheduleQueueId: string;
    public scheduleQueueTaskData: any;

    constructor(private changeDetectorRef: ChangeDetectorRef,
        private dateConverterService: DateConverterService,
        private scheduleQueueService: ScheduleQueueService,
        private scheduleQueueMapperService: ScheduleQueueMapperService,
        private scheduleQueueGridService: ScheduleQueueGridService) {
        
    }

    ngOnInit(): void {
        this.getData();
    }

    private getData() {
        if (this.parentScheduleQueueId) {
            this.scheduleQueueService.getChildren(this.parentScheduleQueueId)
            .subscribe(
                (responses: ScheduleQueueSearchModel[]) => { 
                    this.bindData(responses);
                });
        }
    }

    private bindData(tasks: ScheduleQueueSearchModel[]) {
        if (!tasks?.length) {
            return;
        }
        this.scheduleQueueTaskData = this.scheduleQueueMapperService.bindTaskData(tasks);
        this.changeDetectorRef.detectChanges();
    }

    cellPrepared(e) {
        if (e.rowType != 'data') {
            return;
        }
        if (e.column.dataField == 'result') {
            this.scheduleQueueGridService.setResultCellColor(e)
        } 
    }

    protected formatDateTime(value: any) {
        return this.dateConverterService.formatSystemDateTime(value);
    }
}